import * as React from 'react';

import { cn } from '../cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Renders the Danger-toned invalid state (DESIGN.md §5 "Inputs / Fields"). Pair with a visible error message — never color alone. */
  invalid?: boolean;
}

/**
 * Text input — DESIGN.md §5 "Inputs / Fields": 1px Border stroke, Bg
 * background, 6px radius; focus shifts the border to Chronometer Gold with a
 * 2px ring; error shifts border/ring to Danger.
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', invalid, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          'flex h-9 w-full rounded-sm border border-border bg-bg px-3 py-1 text-body text-ink',
          'placeholder:text-muted',
          // The input is a flex container, so a native date/time picker
          // indicator would otherwise pack left against the value; push it to
          // the trailing edge and give it a pointer cursor. No-op for text
          // inputs, which have no picker indicator.
          '[&::-webkit-calendar-picker-indicator]:ms-auto [&::-webkit-calendar-picker-indicator]:cursor-pointer',
          'transition-colors duration-150 motion-reduce:transition-none',
          'focus-visible:outline-none focus-visible:border-gold focus-visible:ring-2 focus-visible:ring-gold/20',
          'disabled:cursor-not-allowed disabled:opacity-50',
          invalid &&
            'border-danger focus-visible:border-danger focus-visible:ring-danger/20 aria-invalid:border-danger',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
